const API_ENDPOINTS = {
    account: {
        login: 'user/login',
        userRegistration: 'user/userRegistration',
        forgotPassword: 'user/forgotPassword',
        changePassword: 'user/changePassword',
        operatorRegistration: 'user/operatorRegistration',
        operatorList: 'user/operatorList',
        operatorDetail: 'user/operatorDetail',
        updateOperatorLocation: 'user/updateOperatorLocation',
        updateNotificationToken: 'user/updateNotificationToken',
        userList: 'user/list',
        renewTrailSubscription: 'user/renewTrailSubscription'
    },
    subscription: {
        subscriptionList: 'subscription/list',
        addSubscription: 'subscription/addPlan',
        updateSubscription: 'subscription/updatePlan',
        updateStatus: 'subscription/updateStatus',
        updateTransactionStatus: 'transactions/updateStatus',
        newTransaction: 'transactions/newTransaction'
    },
    business: {
        addBusiness: 'business/addBusinessDetails',
        listByLocation: 'business/listByLocation',
        userBusinessList: 'business/businessList',
        details: 'business/updateBusinessDetails',
        updateDetails: 'business/updateDetails',
        checkSubscription: 'business/checkSubscription'
    },
    businessLocation: {
        addLocation: 'location/addLocation',
        list: 'location/list',
        details: 'location/detail',
        updateLocation: 'location/updateLocation',
        updateLocationStatus: 'location/updateLocationStatus'
    },
    location: {
        countryList: 'https://api.countrystatecity.in/v1/countries',
        stateList: 'states',
        cityList: 'cities'
    },
    employee: {
        addEmployee: 'employee/addEmployee',
        employeeList: 'employee/list',
        employeeDetail: 'employee/detail',
        updateDetails: 'employee/updateDetails',
        clockIn: 'employee/shiftStart',
        clockOut: 'employee/shiftEnd',
        attendanceList: 'employee/attendanceList',
        addAvailability: 'availability/addAvailability',
        availabilityList: 'availability/getAvailabilityList',
        updateAvailability: 'availability/update',
        removeFromBusiness: 'employee/removeFromBusiness',
        dashboardData: 'employee/dashboardData',
        loginCodeCheck: 'employee/loginCodeCheck',
        employeeLogin: 'employee/login',
        employeeChangePassword: 'employee/changePassword',
        attendancCheck: 'employee/attendanceCheck'
    },
    project: {
        addProject: 'project/addProject',
        projectList: 'project/list',
        projectDetail: 'project/detail',
        assignEmployee: 'project/assignEmployee',
        removeEmployee: 'project/removeEmployee',
        updateDetails: 'project/updateDetails',
        requestProject: 'project/requestProject',
        rejectRequest: 'project/rejectRequest'
    },
    shift: {
        addShift: 'shift/addShift',
        updateShift: 'shift/update',
        shiftDetail: 'shift/detail',
        shiftList: 'shift/list',
        assignEmployee: 'shift/assignEmployee',
        removeEmployee: 'shift/removeEmployees',
        requestShift: 'shift/shiftRequest',
        declineRequest: 'shift/declineRequest'
    },
    task: {
        addTask: 'task/addTask',
        taskList: 'task/list',
        taskDetail: 'task/detail',
        updateStatus: 'task/updateStatus',
        updateDetail: 'task/updateDetails',
        assignTask: 'task/assignTask',
        addComment: 'task/addComment'
    },
    chat: {
        sendMessage: 'chat/sendMessage',
        chatList: 'chat/chatList',
        messageList: 'chat/messageList'
    },
    request: {
        createRequest: 'request/createRequest',
        updateStatus: 'request/updateRequestStatus',
        detail: 'request/details',
        list: 'request/list'
    },
    document: {
        addDocument: 'documents/addDocument',
        documentList: 'documents/list',
        detail: 'document/detail'
    },
    policies: {
        addPolicy: 'policies/newPolicy',
        detail: 'policies/details',
        list: 'policies/list',
        assignPolicy: 'policies/assignPolicy',
        markComplete: 'policies/markComplete'
    },
    contactUs: {
        newRecord: 'contactUs/newRecord',
        recordList: 'contactUs/messageList'
    },
    assets: {
        newAsset: 'asset/newAsset',
        assetList: 'asset/assetList',
        assetDetail: 'asset/assetDetail',
        assignAsset: 'asset/assignAsset',
        unAssignAsset: 'asset/unAssignAsset',
        updateStatus: 'asset/updateStatus'
    },
    peformance: {
        newRequest: 'performanceReview/newRequest',
        requestList: 'performanceReview/requestList',
        newReview: 'performanceReview/newReview',
        reviewList: 'performanceReview/reviewList',
        newGoal: 'performanceReview/newGoal',
        goalList: 'performanceReview/goalList',
        addGoalComment: 'performanceReview/goalAddComment',
        updateGoalDetails: 'performanceReview/goalUpdate',
        goalDetails: 'performanceReview/goalDetail'
    },
    audit: {
        newAudit: 'audit/newAudit',
        list: 'audit/auditList',
        detail: 'audit/auditDetail',
        assignUser: 'audit/assignUser',
        updateStatus: 'audit/updateStatus',
        addLog: 'audit/addLog',
        updateLogStatus: 'audit/updateLogStatus',
        addLogComment: 'audit/addLogComment'
    },
    visitor: {
        addRecord: 'visitor/addRecord',
        list: 'visitor/visitorList',
        markExit: 'visitor/markExit',
        updateConfiguration: 'visitor/updateConfiguration',
        getConfiguration: 'visitor/getConfiguration'
    },
    payroll: {
        newTaxRule: 'payrollTaxRule/newRule',
        taxRuleList: 'payrollTaxRule/ruleList',
        updateTaxRule: 'payrollTaxRule/updateRule',
        provisionalPayslip: 'payroll/provisionalPayslip',
        newPayslip: 'payroll/newPayslip',
        payslipList: 'payroll/payslipList',
        payslipDetail: 'payroll/payslipDetail',
        updatePaymentStatus: 'payroll/updatePayment'
    },
    merchant: {
        addRecord: 'merchant/addRecord',
        list: 'merchant/list',
        detail: 'merchant/detail',
        updateDetails: 'merchant/updateDetails'
    },
    supplies: {
        category: {
            addCategory: 'supplies/category/addCategory',
            list: 'supplies/category/list',
            updateDetails: 'supplies/category/updateDetails'
        },
        item: {
            addItem: 'supplies/item/addItem',
            list: 'supplies/item/list',
            details: 'supplies/item/detail',
            consumeItem: 'supplies/item/consumeItem',
            updateStock: 'supplies/item/updateStock'
        }
    }
}

export default API_ENDPOINTS